import {
  AgnosticMediaGalleryItem,
  AgnosticAttribute,
  AgnosticPrice,
  ProductGetters
} from '@vue-storefront/core';
import type { Product, ProductFilter, GoodInfo } from '@bee-hole/api';

function getGoods(products: Product[]): Product {
  if (products && products.length > 0) {
    return products[0];
  } else {
    return {
      goodId: 0,
      shopID: 0,
      viewID: 0,
      catId: 0,
      title: '',
      desc: '',
      note: '',
      videoUrl: '',
      imageUrl: 'https://img.alicdn.com/imgextra/i4/20841398/T2wSuHXdlbXXXXXXXX_!!20841398.gif',
      imageUrl1: 'https://img.alicdn.com/imgextra/i4/20841398/T2wSuHXdlbXXXXXXXX_!!20841398.gif',
      imageUrl2: '',
      imageUrl3: '',
      imageUrl4: '',
      isInWishlist: false,
      createTime: '',
      updateTime: '',
      skus: [],
      skuProps: [],
      priceMin: 0,
      priceMax: 0,
      subTitle: ''
    } as Product;
  }
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getName(product: Product): string {
  return product?.title;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getSlug(product: Product): string {
  // return "-";
  let x = product?.slug?.replace(/\//g, '-') || product?.title?.replace(/\//g, '-');
  return x?.replace(/\s+/g, '-').toLowerCase();
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getPrice(product: Product): AgnosticPrice {
  if (product?.skus?.length) {
    if (product.discountPriceMin && product.discountPriceMin < product.priceMin) {
      return {
        regular: product.priceMin,
        special: product.discountPriceMin
      };
    } else {
      return {
        regular: product?.priceMin,
        special: 0
      };
    }
  } else {
    return {
      regular: 0,
      special: 0
    };
  }

}
function getDiscountPrice(product: Product): any {
  if (product?.skus?.length) {
    if (product.discountPriceMin && product.discountPriceMin < product.priceMin) {
      return {
        regular: product.priceMin,
        special: product.discountPriceMin
      };
    } else {
      return {
        regular: product?.priceMin,
        special: 0
      };
    }
  } else {
    return {
      regular: null,
      special: 0
    };
  }
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getGallery(product: Product): AgnosticMediaGalleryItem[] {
  const imgs = [];
  if (product?.videoUrl) {
    imgs.push({
      small: product?.videoUrl,
      normal: product?.videoUrl,
      big: product?.videoUrl
    });
  }
  if (product?.imageUrl) {
    imgs.push({
      small: product?.imageUrl,
      normal: product?.imageUrl,
      big: product?.imageUrl
    });
  }

  if (product?.imageUrl1) {
    imgs.push({
      small: product?.imageUrl1,
      normal: product?.imageUrl1,
      big: product?.imageUrl1
    });
  }

  if (product?.imageUrl2) {
    imgs.push({
      small: product?.imageUrl2,
      normal: product?.imageUrl2,
      big: product?.imageUrl2
    });
  }

  if (product?.imageUrl3) {
    imgs.push({
      small: product?.imageUrl3,
      normal: product?.imageUrl3,
      big: product?.imageUrl3
    });
  }

  if (product?.imageUrl4) {
    imgs.push({
      small: product?.imageUrl4,
      normal: product?.imageUrl4,
      big: product?.imageUrl4
    });
  }
  if (product?.imageUrl5) {
    imgs.push({
      small: product?.imageUrl5,
      normal: product?.imageUrl5,
      big: product?.imageUrl5
    });
  }
  if (product?.imageUrl6) {
    imgs.push({
      small: product?.imageUrl6,
      normal: product?.imageUrl6,
      big: product?.imageUrl6
    });
  }
  if (product?.imageUrl7) {
    imgs.push({
      small: product?.imageUrl7,
      normal: product?.imageUrl7,
      big: product?.imageUrl7
    });
  }
  if (product?.imageUrl8) {
    imgs.push({
      small: product?.imageUrl8,
      normal: product?.imageUrl8,
      big: product?.imageUrl8
    });
  }
  if (product?.imageUrl9) {
    imgs.push({
      small: product?.imageUrl9,
      normal: product?.imageUrl9,
      big: product?.imageUrl9
    });
  }
  return imgs;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getCoverImage(product: Product): string {
  return product?.imageUrl;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getFiltered(products: Product[], filters: ProductFilter): Product[] {
  // console.log('getFiltered----------------', products, filters);
  return products;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getAttributes(products: Product[] | Product, filterByAttributeName?: string[]): Record<string, AgnosticAttribute | string> {
  return {};
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getDescription(product: Product): string {
  return product?.desc;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getCategoryIds(product: Product): string[] {
  return [];
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getId(product: Product): string {
  return product?.goodId?.toString();
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getFormattedPrice(price: number): string {
  return '';
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getTotalReviews(product: Product): number {
  return 0;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getAverageRating(product: Product): number {
  return product?.rate || 0;
}

function getBreadcrumbs(product: Product): any[] {
  const links = [
    {
      text: 'Home',
      link: '/'
    },
    {
      text: 'Categories',
      link: '/c/' + product?.catId
    }
  ];
  return links;
}
function newGetBreadcrumbs(product: GoodInfo): any[] {
  let links = [];
  if (product?.catTree) {
    product.catTree.map(cat => {
      // 倒叙
      links.unshift({
        text: cat.name,
        link: '/c/' + cat.catId
      });
    });
    links.unshift({
      text: 'Home',
      link: '/'
    });
  } else {
    links = [
      {
        text: 'Home',
        link: '/'
      },
      {
        text: 'Categories',
        link: '/c/' + product?.catId
      }
    ];
  }
  return links;
}
function getImages(products: any[]): any {
  if (products) {
    products.map(product => {
      const imgs = [];
      if (product?.imageUrl) {
        imgs.push({
          small: product?.imageUrl,
          normal: product?.imageUrl,
          big: product?.imageUrl
        });
      }

      if (product?.imageUrl1) {
        imgs.push({
          small: product?.imageUrl1,
          normal: product?.imageUrl1,
          big: product?.imageUrl1
        });
      }

      if (product?.imageUrl2) {
        imgs.push({
          small: product?.imageUrl2,
          normal: product?.imageUrl2,
          big: product?.imageUrl2
        });
      }

      if (product?.imageUrl3) {
        imgs.push({
          small: product?.imageUrl3,
          normal: product?.imageUrl3,
          big: product?.imageUrl3
        });
      }

      if (product?.imageUrl4) {
        imgs.push({
          small: product?.imageUrl4,
          normal: product?.imageUrl4,
          big: product?.imageUrl4
        });
      }
      if (product) {
        product.images = imgs;
      }
    });
  }
  return products;
}

export const productGetters: ProductGetters<Product, ProductFilter> = {
  getGoods,
  getName,
  getSlug,
  getPrice,
  getGallery,
  getCoverImage,
  getFiltered,
  getAttributes,
  getDescription,
  getCategoryIds,
  getId,
  getFormattedPrice,
  getTotalReviews,
  getAverageRating,
  getBreadcrumbs,
  getDiscountPrice,
  getImages,
  newGetBreadcrumbs
};
